const formIdentityKeys = [
	"formName",
	"collection",
	"col",
	"settingId",
	"appVersion",
	"buildVersion",
	"pathname",
];

export const getCanonicalFormResponses = (
	responses = {},
	formIdentity = {},
) => {
	const canonicalResponses = { ...responses };

	for (const key of formIdentityKeys) {
		if (formIdentity[key] !== undefined) {
			canonicalResponses[key] = formIdentity[key];
		}
	}

	return canonicalResponses;
};

export const applyFormResponseUpdates = (
	responses = {},
	updates = {},
	formIdentity = {},
) =>
	getCanonicalFormResponses(
		{
			...responses,
			...updates,
		},
		formIdentity,
	);

export const putCanonicalFormResponses = async (
	db,
	formName,
	responses = {},
	formIdentity = {},
) => {
	const canonicalResponses = getCanonicalFormResponses(
		responses,
		formIdentity,
	);

	await db.put("formData", canonicalResponses, formName);

	return canonicalResponses;
};
